const colorScale = {
    blue: {
        100: "#E3E8F0",
        200: "#BEC9DD",
        300: "#869AC0",
        400: "#4F6CA3",
        500: "#173D86",
        600: "#122F68",
        700: "#0C2046",
        800: "#061126",
    },
    blueContrast: {
        100: "#F6F6F6",
        200: "#E8E8E9",
        300: "#BFBFC3",
        400: "#89888F",
        500: "#52515B",
        600: "#373541",
        700: "#1C1A27",
        800: "#0F0E14",
    },
    yellow: {
        100: "#FEF5D6",
        200: "#FDEEB8",
        300: "#FCDF7A",
        400: "#FAD13D",
        500: "#F9C200",
        600: "#BD9300",
        700: "#816500",
        800: "#463600",
    },
    calm: {
        100: "#F4F7FA",
        200: "#ECF1F6",
        300: "#DCE5EE",
        400: "#CBD9E7",
        500: "#BBCDDF",
        600: "#8E9CA9",
        700: "#616B74",
        800: "#434A50",
    },
    clarity: {
        100: "#FBF8F5",
        200: "#F9F5F1",
        300: "#E3DFDB",
        400: "#BDBAB7",
        500: "#9F9D9A",
        600: "#73716F",
        700: "#646260",
        800: "#555352",
    },
    good: {
        100: "#EDF5EE",
        200: "#D2E6D3",
        300: "#A6CEA8",
        400: "#79B57C",
        500: "#4C9C50",
        600: "#39753C",
        700: "#264E28",
        800: "#132714",
    },
    warning: {
        100: "#FEF8EC",
        200: "#FCEDCF",
        300: "#F9DBA0",
        400: "#F6C870",
        500: "#D67D00",
        600: "#B68930",
        700: "#7A4D20",
        800: "#3D2710",
    },
    error: {
        100: "#F9EBEC",
        200: "#F1CED0",
        300: "#E29DA1",
        400: "#D46B71",
        500: "#C53A42",
        600: "#942C32",
        700: "#631D21",
        800: "#310F11",
    },
    white: "#FFFFFF",
};
const colors = {
    primary: colorScale.blue[500],
    primaryLight: colorScale.blue[100],
    neutralPrimary: colorScale.blueContrast[700],
    neutralPrimaryLight: colorScale.blueContrast[200],
    accentPrimary: colorScale.calm[500],
    accentPrimaryLight: colorScale.calm[200],
    accentPrimaryDark: colorScale.calm[800],
    accentSecondary: colorScale.yellow[500],
    accentSecondaryLight: colorScale.yellow[100],
    neutral: colorScale.clarity[100],
    neutralLight: colorScale.white,
    neutralDark: colorScale.clarity[300],
    neutralDark2: colorScale.clarity[400],
    neutralDark3: colorScale.clarity[700],
    divider: colorScale.clarity[300],
    dividerDark: colorScale.clarity[500],
    textPrimary: colorScale.blueContrast[700],
    textSecondary: colorScale.clarity[800],
    textTertiary: colorScale.clarity[700],
    textInactive: colorScale.blueContrast[500],
    textContrast: colorScale.white,
    systemGood: colorScale.good[500],
    systemGoodLight: colorScale.good[100],
    systemGoodDark: colorScale.good[600],
    systemWarning: colorScale.warning[500],
    systemWarningLight: colorScale.warning[100],
    systemWarningDark: colorScale.warning[700],
    systemError: colorScale.error[500],
    systemErrorLight: colorScale.error[100],
    systemErrorDark: colorScale.error[600],
    systemInfoLight: colorScale.blue[100],
    systemInfoDark: colorScale.blueContrast[700],
};

export { colorScale, colors };
